<!------------------------------------------------------------------------------
 File: SalesTotalByEvent
 Created by keni.
 with: IntelliJ IDEA
 Date: 03/07/2018
 Time: 12:38
------------------------------------------------------------------------------->
<template>
    <section class="pl-3 pr-3 mb-3">

        <!--sort by rows-->
        <div class="card">
            <div class="card-header">
                <div class=" text-light">
                    <div class="d-flex justify-content-between align-items-top ">
                        <div>
                            <div class="d-inline-block" v-html="page_title"></div>
                            <div class="small" v-if="expires !== ''">Refreshes: {{expires}}</div>
                            <div class="d-inline-block dashboard-module-small--value ml-2">
                                {{currency}}{{money(sale_total)}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="table-max-height watch-transition"
                     :class="{
                            'table-max-height--extended':selected_event.id !== null
                        }"
                >
                    <div class="table-responsive">
                        <div class="d-table table table-striped">
                            <div class="thead">
                                <div class="d-table-row">
                                    <div class="th">Event</div>
                                    <div class="th">Event Date</div>
                                    <div class="th text-right">Amount</div>
                                    <div class="th text-right">Sold</div>
                                </div>
                            </div>
                            <div class="tbody">
                                <!--start the row-->
                                <template
                                    v-if="products"
                                    v-for="event in products"
                                >
                                    <div class="d-table-row cursor-pointer"
                                         :class="{
                                                        'bg-primary':event.show_detail == true
                                                    }"

                                         :key="event.id"
                                         v-on:click="updateSelectedEvent(event)"
                                    >
                                        <!--{{log(getSelectedEvent(event).active)}}-->
                                        <div class="td ">
                                            {{lang('title',event.event_data.lang)}}
                                        </div>
                                        <div class="td text-right">
                                            {{makeDate(event.start_date.date)}}
                                        </div>
                                        <div class="td text-right">
                                            {{currency}}{{money(event.sold_total)}}
                                        </div>
                                        <div class="td text-right">
                                            {{event.sold_count}}
                                        </div>
                                    </div>
                                    <div class="d-table-row" data-event-tickets-module>
                                        <template
                                            v-if="selected_event.id == event.id"

                                        >
                                            {{log(event)}}
                                            <event-tickets-module
                                                colspan="3"
                                                :no_header="true"
                                                :no_card="true"
                                                :is_table="true"
                                                data-type="event-tickets-module"
                                                :currency="currency"
                                                :event_data="event"
                                                :event_tickets="event.tickets"
                                                :sale_route_uri="sale_route_uri"
                                            ></event-tickets-module>
                                        </template>
                                    </div>
                                </template>

                            </div>
                            <!--<transition-group name="fade" tag="div" class="tbody">-->
                            <!---->
                            <!--</transition-group>-->
                            <div class="tfoot">
                                <div class="d-table-row">
                                    <div class="d-table-cell text-right font-weight-bold ">
                                        Total
                                    </div>
                                    <div class="d-table-cell text-right">
                                        {{money(sale_total)}}
                                    </div>
                                    <div class="d-table-cell text-right"></div>
                                    <!--<div class="d-table-cell"></div>-->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { percentage } from '../../../../../app/Shared/Resources/Assets/js/helpers/calc';
    import { endOfMonth, endOfDay, endOfWeek, endOfYear } from 'date-fns';
    import {
        getDate,
        DATE_FORMAT,
        TIME_FORMAT
    } from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import { format as formatMoney } from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
    import { length as _obj_size } from '../../../../../app/Shared/Resources/Assets/js/helpers/object.formats';

    Vue.component('event-tickets-module', require('./EventTicketsModule'));
    export default {
        name: 'sales-total-by-event',
        components: {},
        props: {
            title: String,
            progress_bar_height: String,
            request_route_uri: String,
            filter_date: String,
            date_frequency: String,
            sale_route_uri: String,
            id_prefix: {
                type: String,
                default: function() {
                    return 'evt-';
                }
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            let self = this;
            // console.log('mounted', 'hi');
            if (typeof this.progress_bar_height !== 'undefined' && this.progress_bar_height !== null) {
                this.progress_bar.height = Number(this.progress_bar_height);
            }
            if (typeof this.title !== 'undefined' && this.title !== null) {
                // this.page_title = this.title;
            }
            this.$nextTick(function() {
                self.report();
            });
        },
        data() {
            return {
                sale_total: 0,
                sale_count: 0,
                sale_refunded: 0,
                sale_allocation: 0,
                expires:'',
                multiple_event_tickets: {
                    sale_total: 0,
                    sale_count: 0,
                    sale_refunded: 0,
                    sale_allocation: 0
                },
                currency: '£',
                page_title: 'Total sales by event',
                show_graph: false,
                /**
                 * @property {Number}   product.sold
                 * @property {Number}   product.remaining
                 * @namespace {object}  product
                 */
                products: [],
                selected_event_tickets: [],
                selected_events: {
                    //                    type:Object
                    //        id:{
                    //            id: null,
                    //            tickets: [],
                    //            event: {},
                    //            name: ''
                    //        }
                },
                selected_event: {
                    id: null,
                    tickets: [],
                    event: {},
                    name: ''
                },
                progress_bar: {
                    height: 16
                },
                frequency_start: '',
                frequency_end: ''
            };
        },
        methods: {
            makeDate(date) {
                return getDate(date, DATE_FORMAT.tiny + ' ' + TIME_FORMAT);
            },
            lang(path, object) {
                return lang(path, object);
            },
            money(price, params) {
                return formatMoney(price, params);
            },
            getId(id) {
                let self = this;
                return `${self.id_prefix}${id}`;
            },
            getSelectedEvent(event) {
                let self = this;

                if (typeof event !== 'undefined' && event !== null) {
                    let eventId = self.getId(event.id);

                    //                console.log('getSelectedEvent', 'event',event,self.selected_events);

                    //                return false;
                    //                if(_.isEmpty(self.selected_events)){
                    //
                    //                }

                    //                    console.log('getSelectedEvent', 'eventId',eventId);
                    if (_.isEmpty(self.selected_events) || !self.selected_events.hasOwnProperty(eventId)) {
                        self.selected_events[eventId] = {
                            id: event.id,
                            tickets: event.tickets,
                            event: event,
                            name: event.name,
                            active: false
                        };
                    }
                    //                    console.log('getSelectedEvent', 'self.selected_events[eventId]',self.selected_events[eventId]);
                    return self.selected_events[eventId];
                }
                return null;
            },
            updateSelectedEvent(event) {

                let self = this;

//                event.show_detail = !event.show_detail;

                let id = event.id, set = false;

                if (self.products[id].show_detail == true) {
                    set = false;
                } else {
                    set = true;
                }
                self.products[id].show_detail = set;

                if(set = true){
                    if(self.selected_event.id !== null){
                        self.products[self.selected_event.id].show_detail = false;

                    }

                    self.selected_event.id=id;
                }

                console.log('updateSelectedEvent', 'self.products[id].show_detail', self.products[id].show_detail);
                //                self.products[id].show_detail = !self.products[id].show_detail;

                //                console.log('updateSelectedEvent', 'self.products[id]',self.products[id]);

                //                let eventId = self.getId(event.id);
                //                if (_.isEmpty(self.selected_events) ||  !self.selected_events.hasOwnProperty(eventId)) {
                //                    self.selected_events[eventId] = {
                //                        id: event.id,
                //                        tickets: event.tickets,
                //                        event: event ,
                //                        name: event.name ,
                //                        active:false
                //                    };
                //                }else{
                //                    self.selected_events[eventId].active = !self.selected_events[eventId].active;
                //                }
                //                console.log('updateSelectedEvent', 'eventId',eventId,self.selected_events[eventId]);

                // if its open then what?
                //                console.log('updateSelectedEvent', 'this.show_graph',this.show_graph);
                //                self.selected_event = {};
                //                self.selected_event = {
                //                    id: null,
                //                    tickets: [],
                //                    event: {},
                //                    name: ''
                //                };

                // if it wasnt open then close the others
                //                if(self.show_graph == false){
                //                    self.show_graph = true;
                //
                //
                //                }

                //                console.log('updateSelectedEvent', 'self.selected_event', self.selected_event);

                //                self.show_graph = self.selected_events[eventId].active;
                self.$nextTick(function() {
                    //                    if (self.show_graph == true) {
                    ////                        console.log('opening');
                    //                        self.selected_event.id = event.id;
                    //
                    //                        self.selected_event.event = event;
                    //                        self.selected_event.name = event.name;
                    //
                    //                        self.selected_event.tickets = event.tickets;
                    //                    }
                });

                //                console.log('updateSelectedEvent', 'this.show_graph',self.show_graph);

                // console.log('updateSelectedEvent', 'event test',event);

            },
            setFrequency(self, origin) {
                // console.log('setFrequency', 'origin', origin);
                return new Promise(() => {

                    let
                        date = (
                            self.filter_date != ''
                        ) ?
                            self.filter_date :
                            new Date(),
                        frequency = (
                            typeof self.date_frequency !== 'undefined' && self.date_frequency !== null
                        ) ?
                            self.date_frequency :
                            'monthly';

                    switch (frequency) {
                        case 'daily':
                            self.frequency_start = date;
                            self.frequency_end = endOfDay(date);
                            break;
                        case 'weekly':
                            self.frequency_start = date;
                            self.frequency_end = endOfWeek(date);
                            break;
                        case 'monthly':
                            self.frequency_start = date;
                            self.frequency_end = endOfMonth(date);
                            break;
                        case 'yearly':
                            self.frequency_start = date;
                            self.frequency_end = endOfYear(date);
                            break;
                    }
                });
            },
            getTitle(self) {

                return new Promise(() => {
                    // console.log('getTitle', 'self', self);
                    let start = getDate(self.frequency_start),
                        end = getDate(self.frequency_end),
                        name = self.title,
                        dates = `${start} - ${end}`;
                    this.page_title = `
<div>${name}</div>
<div>${dates}</div>
`;
                    // console.log('getTitle', 'this.page_title ', this.page_title);
                });

            },
            setTotal(self) {
                let size = _obj_size(self.products);

                if (size > 0) {

                    // let totals = _.pluck(self.products, 'sold_total');
                    // console.log('setTotal', 'before loop');

                    for (let productsKey in self.products) {
                        // console.log('setTotal', 'productsKey', productsKey);
                        /**
                         * @property sold_total
                         * @property allocation
                         * @property refunded
                         * @namespace
                         */
                        let eventSet = self.products[productsKey];

                        if (eventSet.event_data.lang.en_GB.title == 'keni new') {
                            console.log('setTotal', 'eventSet', eventSet);
                        }
                        self.sale_total = self.sale_total + eventSet.sold_total;
                    }
                }
                // console.log('setTotal', 'this.sale_total', self.sale_total);
            },
            returnPercentage(value, remaining, fn) {
                if (typeof fn == 'function') {
                    return percentage(value, value + remaining, fn);
                }
                else {
                    return percentage(value, value + remaining);
                }
            },
            log(...args) {
                console.log(...args);
            },
            report() {
                let self = this,
                    data = {
                        type: 'sales-total-events',
                        filter_date: self.filter_date,
                        frequency: self.date_frequency
                    };

                axios.post(this.request_route_uri, data)
                    .then(self.compileEventsReport)
                    .catch(function() {
                    });
            },
            compileEventsReport(response) {
                let self = this;

                // console.log('compileEventsReport', 'self', response.data.sales);
                if (response.data.success) {
                    self.products = response.data.sales;
                    if(response.data.hasOwnProperty('expires')){
                        self.expires  = response.data.expires;
                    }

//                    self.set(self.products,response.data.sales);

                    for (let productsKey in self.products) {
                        self.products[productsKey].show_detail = false;
                    }

                    self.sale_total = 0;

                    self.setFrequency(self, 'report')
                        .then(self.getTitle(self))
                        .then(self.setTotal(self));

//                    console.log('report', 'after setTotal');

                }
                else {
                    console.error('compileEventsReport', 'response not successful');
                }
            }
        },
        watch: {
            products() {
                let self = this;
                if (self.products.length > 0) {
                    // console.log('products', 'updating');
                    self.sale_total = 0;
                    self.setFrequency(self, 'report')
                        .then(self.getTitle(self))
                        .then(self.setTotal(self));
                }

            },
            progress_bar_height(val) {
                this.progress_bar.height = Number(val);
            },
            currency(val) {
                this.currency = val;
            },
            filter_date(date) {
                // console.log('filter_date', date);
                this.products = [];

                this.filter_date = date;
                // getDate(self.local_filter_date, 'data_base')
                this.report();
            }
        },
        computed: {
            hasShow:function(obja){

                console.log('hasShow', 'obj',obja);
                return true
            }
        }
    };
</script>

<style scoped>
    .table-max-height {
        overflow-x: hidden;
        overflow-y: scroll;
        height: 20vh;
    }

    .table-max-height--extended {
        height: 50vh;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/SalesTotalByEvent.vue?2f292358